import { APP_VARIABLES, CLEVER_TAP_EVENTS } from '@constants/app-constants';
import { CloseCircleOutlined, CloseOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import { Col, Divider, Form, Input, Row, Select } from 'antd';
import React, { useEffect, useLayoutEffect, useState } from 'react';

import AtmMapFunctional from './atm-location-map/AtmMapFunctional';
import EdenredButton from '@sharedComponent/button';
import Footer from './Footer/Footer';
import Header from './Header/Header';
import ImageComponent from '@sharedComponent/image-component';
import LocationList from './LocationList';
import MobileAtmFunctional from './atm-location-map/mobile-map/MobileAtmFunctional';
import MobileFilter from './MobileFilter';
import { Option } from 'antd/lib/mentions';
import OptionTick from './OptionTick';
import SelectComponent from './SelectComponent';
import TextComponent from '@sharedComponent/typography/TextComponent';
import { images } from 'src/assets/img';

const AtmLocationsPresentational = (
	{
		setEnableLocationPromt,
		data,
		onAtmClick,
		atmCoordinates,
		emiratesLocation,
		atmlocationData,
		isAtmLoading,
		setRakbankAtm,
		setAtmsC,
		atmsC,
		rakbankAtm,
		searchFilter,
		selectedEmirate,
		emiratesStates,
		setEmiratesStates,
		markerOff,
		allEmirates,
		locationList,
		infoData,
		setatmData,
		defaultSwitch,
		nodata,
		setNodata,
		setLocationData,
		locationData,
		EnableLocation,
		enableLocationPromt,
	},
	props
) => {
	const [isFilter, setFilter] = useState(false);
	const [isMapEnabled, setIsMapEnabled] = useState(false);
	const [isLocation, setIsLocation] = useState(true);
	const [isDropdown, setIsDropdown] = useState(false);
	const [c3key, setC3key] = useState(null);

	return (
		<>
			{/* <Header /> */}
			{enableLocationPromt && (
				<div className="map-enable-location" onClick={() => EnableLocation(false)}>
					<div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', cursor: 'pointer' }}>
						<CloseOutlined />
					</div>
					<div className="sub-map--enable-location">
						<div>Enable Location</div>
						<div style={{ paddingLeft: 5 }}>
							<img src={images.caution} alt="" className="caution-img" />
						</div>
					</div>
				</div>
			)}
			<Row className="sub-row-container container-main">
				<div className="sub-container">
					<div className="atm-inputs search-inp">
						{' '}
						<Input
							placeholder="Search by Location"
							onfocus="this.placeholder = ''"
							onblur="this.placeholder = 'enter your text'"
							prefix={<img className="filter-icon" src={images.searchSvg} />}
							className="atm-input-fields input-box-atm-search"
							onChange={searchFilter}
						/>
					</div>
					<div className="atm-inputs select-inp">
						<SelectComponent emiratesLocation={emiratesLocation} selectedEmirate={selectedEmirate} />
					</div>
					<div className="atm-inputs round c3-box">
						<div className="round-sub" id="checkbox" onClick={() => setAtmsC(!atmsC)}>
							<div className="tick-icon">
								{atmsC ? <ImageComponent className="tick-enabled" /> : <ImageComponent className="tick" />}
							</div>
							<div className="label-check">C3Pay ATMs</div>
						</div>
					</div>

					<Col className="atm-inputs round check-box-end rak-box">
						<div className="round-sub2" id="checkbox" onClick={() => setRakbankAtm(!rakbankAtm)}>
							<div className="tick-icon">
								{rakbankAtm ? <ImageComponent className="tick-enabled" /> : <ImageComponent className="tick" />}
							</div>
							<div className="label-check">RAKBANK ATMs</div>
						</div>
					</Col>
				</div>
			</Row>

			<Col
				className={isMapEnabled ? 'atm-main-container-map container-main' : 'atm-main-container container-main'}
				xl={24}
				lg={24}
				md={24}
				sm={24}
				xs={24}>
				{/* mobile */}
				<Row className="mobile-outer-main">
					<Col xs={8} className="atm-inputs-mobile">
						<div
							onClick={() => setFilter(!isFilter)}
							className="ant-input-affix-wrapper atm-input-fields filter-mobile-parent"
							style={{ width: '100%', height: 40 }}>
							<span>
								<img className="filter-icon" src={images.filtericon}></img>
							</span>
							<span className="atm-input-fields filter-custom">Filters</span>
						</div>
					</Col>
					<Col xs={16} className="atm-inputs-mobile">
						<div style={{ width: '100%', height: 40 }}>
							<div className="atm-inputs search-inp search-inp-mobile">
								<Input
									placeholder="Search by Location"
									onfocus="this.placeholder = ''"
									onblur="this.placeholder = 'enter your text'"
									prefix={<img className="filter-icon" src={images.searchSvg} />}
									className="atm-input-fields input-box-atm-search"
									onChange={searchFilter}
								/>
							</div>
						</div>
					</Col>
				</Row>
				{isFilter && (
					<MobileFilter
						atmsC={atmsC}
						setAtmsC={setAtmsC}
						rakbankAtm={rakbankAtm}
						setRakbankAtm={setRakbankAtm}
						isFilter={isFilter}
						setFilter={setFilter}
						emiratesLocation={emiratesLocation}
						emiratesStates={emiratesStates}
						setEmiratesStates={setEmiratesStates}
					/>
				)}
				<Row className="row-con-3 map-con">
					{!isFilter && isLocation && (
						<Col xl={9} lg={9} md={9} sm={24} xs={24} className="list-container-col animation-fade mobile-map">
							<div className="data-atm-list-container">
								<LocationList
									setFilter={setFilter}
									data={data}
									onAtmClick={onAtmClick}
									atmlocationData={atmlocationData}
									isAtmLoading={isAtmLoading}
									rakbankAtm={rakbankAtm}
									c3atm={atmsC}
									selectedEmirate={selectedEmirate}
									setIsMapEnabled={setIsMapEnabled}
									setIsLocation={setIsLocation}
									setatmData={setatmData}
									nodata={nodata}
									setNodata={setNodata}
									setLocationData={setLocationData}
									locationData={locationData}
									setC3key={setC3key}
									c3key={c3key}
								/>
							</div>
						</Col>
					)}
					<Col xl={9} lg={9} md={9} sm={9} xs={24} className="list-container-col animation-fade desktop-map">
						<div className="data-atm-list-container">
							<LocationList
								data={data}
								onAtmClick={onAtmClick}
								atmlocationData={atmlocationData}
								isAtmLoading={isAtmLoading}
								rakbankAtm={rakbankAtm}
								c3atm={atmsC}
								selectedEmirate={selectedEmirate}
								setIsMapEnabled={setIsMapEnabled}
								setIsLocation={setIsLocation}
								setatmData={setatmData}
								nodata={nodata}
								setNodata={setNodata}
								setLocationData={setLocationData}
								locationData={locationData}
								setC3key={setC3key}
								c3key={c3key}
							/>
						</div>
					</Col>
					{!isFilter && isMapEnabled && (
						<Col xl={15} lg={15} md={15} sm={15} xs={24} className="map-container animation-fade mobile-map">
							<MobileAtmFunctional
								setEnableLocationPromt={setEnableLocationPromt}
								EnableLocation={EnableLocation}
								nodata={nodata}
								setNodata={setNodata}
								atmCoordinates={atmCoordinates}
								google={props.google}
								center={{ lat: atmCoordinates.lat, lng: atmCoordinates.long }}
								height="85vh"
								zoom={15}
								mylocation={false}
								search={false}
								atmsC={atmsC}
								rakbankAtm={rakbankAtm}
								atmlocationData={atmlocationData}
								markerOff={markerOff}
								allEmirates={allEmirates}
								selectedEmirate={selectedEmirate}
								locationList={locationList}
								infoData={infoData}
								defaultSwitch={defaultSwitch}
								setC3key={setC3key}
								c3key={c3key}
							/>
						</Col>
					)}
					<Col xl={15} lg={15} md={15} sm={15} xs={24} className="map-container animation-fade desktop-map">
						<AtmMapFunctional
							setEnableLocationPromt={setEnableLocationPromt}
							EnableLocation={EnableLocation}
							nodata={nodata}
							setNodata={setNodata}
							atmCoordinates={atmCoordinates}
							google={props.google}
							center={{ lat: atmCoordinates.lat, lng: atmCoordinates.long }}
							height="85vh"
							zoom={15}
							mylocation={false}
							search={false}
							atmsC={atmsC}
							rakbankAtm={rakbankAtm}
							atmlocationData={atmlocationData}
							markerOff={markerOff}
							allEmirates={allEmirates}
							selectedEmirate={selectedEmirate}
							locationList={locationList}
							infoData={infoData}
							defaultSwitch={defaultSwitch}
							setC3key={setC3key}
							c3key={c3key}
						/>
					</Col>
					{!isFilter && (
						<div className={isMapEnabled ? 'map-btn-hide-main-false' : 'map-btn-hide-main'}>
							<button
								className="map-btn map-show-btn"
								onClick={() => {
									setIsMapEnabled(!isMapEnabled);
									setIsLocation(isMapEnabled);
								}}>
								{isMapEnabled ? 'HIDE MAP' : 'SHOW MAP'}
							</button>
						</div>
					)}
				</Row>
			</Col>
			{/* <Footer /> */}
		</>
	);
};

export default AtmLocationsPresentational;
